
import type { PropType } from 'vue'
import type { OktellClient } from '@/core/types/oktell.types'
import type { CreateDealPayload } from '@/core/types/preferences.types'

import { defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import TheTextarea from '@/common/components/UI/TheTextarea/index.vue'

import { preferences } from '@/core/realisations/preferences.realisation'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        Modal,
        TheTextarea
    },
    props: {
        client: {
            type: Object as PropType<OktellClient>,
            default: null,
        },
        phone: {
            type: String as PropType<string | null>,
            default: null,
        },
    },
    emits: ['cancel', 'submitted'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            comment: null as string | null,
        })

        const onCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const onSubmit = async () => {
            if (state.is_loading) return

            try {
                state.is_loading = true

                const payload: CreateDealPayload = {
                    name: props.client ? props.client.fullName : 'Неизвестный клиент',
                    phoneNumber: props.phone as string,
                    themeId: 25,
                    deal: state.comment
                }

                await preferences.createDeal(payload)

                notifications.notify({ type: 'success', title: 'Клиент передан в отдел продаж' })
                emit('submitted')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При передаче клиента отделу продаж произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            onCancel,
            onSubmit
        }
    }
})
